export enum ManagementLevel {
    PotentialInteractionRisk = 1,
    ProfessionalReviewSuggested = 2,
    ProfessionalInterventionRequired = 3,
}
